import React, { useState } from 'react';
import { Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { MenuItemDetail } from './MenuItemDetail';
import './Menu.css';

export const MenuItem = ({ item, selectedTable, onOrderUpdate}) => {
  const [modal, setModal] = useState(false); 

  const toggleModal = () => setModal(!modal);
  const amountAfterDiscount =
  item.discountDetail && item.discountDetail.discountPercentage
    ? item.price - (item.price * item.discountDetail.discountPercentage) / 100
    : item.price;

    const handleOrderComplete = async () => {
      await onOrderUpdate();
      toggleModal();
    };
  return (
    <Col lg={3} md={4}  sm={6} className="mb-3">
      <div 
        className="organization-sales-menu-item p-2 shadow-sm right ribbon-box rounded cursor-pointer"
        onClick={toggleModal} 
      >
        <img
          src={item?.cloudR2ImagePath?.getCDNUrl() || 'https://via.placeholder.com/150'}
          alt={item.title}
          className="mb-0"
        />
        <p className="p-0 fs-6 m-0 fw-bold text-black">{item.title}</p>
        <p className="p-0 fs-6 mb-0 text-end">
          {item.discountDetail && item.discountDetail.discountPercentage > 0 ? (
            <>
              <span className="text-decoration-line-through me-2 text-danger">Rs. {item.price}</span>
              <span className='text-black'>Rs. {amountAfterDiscount}</span>
            </>
          ) : (
            <span className='text-black'>Rs. {item.price}</span>
          )}
        </p>
        {item.discountDetail && item.discountDetail.discountPercentage > 0 && (
          <div className="ribbon-two ribbon-two-primary">
            <span className="text-white ms-2">
              {item.discountDetail.discountPercentage}% OFF
            </span>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{item.title}</ModalHeader>
        <ModalBody>
          <MenuItemDetail item={item} onClose={handleOrderComplete} selectedTable={selectedTable} /> 
        </ModalBody>
      </Modal>
    </Col>
  );
};